"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toJson = void 0;
const toJson = (resource, shouldPrettify = true) => {
    let jsonResource = JSON.stringify(resource);
    if (shouldPrettify) {
    }
    return jsonResource;
};
exports.toJson = toJson;
//# sourceMappingURL=toJson.js.map